import Header from "../components/Header";
import { useState, useEffect, useRef, useMemo } from "react";
import { motion, useAnimation } from "framer-motion";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();
    const images = [
        window.innerWidth > 1400 ? "/assets/car1.jpg" : "/assets/car1mob.jpg",
        window.innerWidth > 1400 ? "/assets/car2.jpg" : "/assets/car2mob.jpg",
        window.innerWidth > 1400 ? "/assets/car3.jpg" : "/assets/car3mob.jpg"
    ];

    const imagesSocios = [
        { src: "/assets/socio1.png", name: "Rafael Gonçalves" },
        { src: "/assets/socio2.jpeg", name: "Ruy Trevisan" },
        { src: "/assets/socio3.png", name: "Edemilso Batista" }
    ]

    const solucoes = [
        { title: "CONSULTORIA", description: "No Brasil, a área fiscal, tributária e contábil é extremamente complexa e sofre atualizações diárias. Assim, no dia a dia da empresa e de sua equipe [...]", src: "/assets/solucao1.png" },
        { title: "ESTRATÉGIAS OPERACIONAIS E PLANEJAMENTO TRIBUTÁRIO", description: "A FiscalTec, por meio do planejamento tributário, auxilia seus clientes na análise e na revisão [...]", src: "/assets/solucao2.png" },
        { title: "CONTÁBIL, FISCAL E DEPARTAMENTO PESSOAL", description: "Oferecemos serviços integrados de contabilidade, fiscal e RH, garantindo a conformidade com as normas vigentes e [...]", src: "/assets/solucao3.png" },
        { title: "COMPLIANCE TRIBUTÁRIO", description: "O sistema tributário brasileiro é extremamente complexo, o que dificulta a administração das obrigações LEGAIS de [...]", src: "/assets/solucao4.png" },
        { title: "CLASSIFICAÇÃO E RECLASSIFICAÇÃO FISCAL", description: "A atividade é importante para empresas cuja operação dependa de grande diversidade de produtos, principalmente do ramo de importaçãoe [...]", src: "/assets/solucao4.png" },
        { title: "ASSESSORIA CUSTOMIZADA", description: "A adoção pontual e a implementação de trabalhos fiscais e contábeis específicos, por tratarem de [...]", src: "/assets/solucao4.png" },
    ]

    const [index, setIndex] = useState(0);

    // 👉 Autoplay (troca automática)
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((i) => (i + 1) % images.length);
        }, 3000); // troca a cada 4 segundos

        return () => clearInterval(interval); // limpa ao desmontar
    }, [images.length]);

    const next = () => setIndex((i) => (i + 1) % images.length);
    const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);

    const [indexSocio, setIndexSocio] = useState(0);

    // 👉 Autoplay (troca automática)
    useEffect(() => {
        const interval = setInterval(() => {
            setIndexSocio((i) => (i + 1) % imagesSocios.length);
        }, 7000); // troca a cada 4 segundos

        return () => clearInterval(interval); // limpa ao desmontar
    }, [imagesSocios.length]);

    const nextSocio = () => setIndexSocio((i) => (i + 1) % imagesSocios.length);
    const prevSocio = () => setIndexSocio((i) => (i - 1 + imagesSocios.length) % imagesSocios.length);

    const [img1Hover, setImg1Hover] = useState("/assets/img1.png");
    const [img2Hover, setImg2Hover] = useState("/assets/img2.png");
    const [img3Hover, setImg3Hover] = useState("/assets/img3.png");
    const [img4Hover, setImg4Hover] = useState("/assets/img4.png");
    const [img5Hover, setImg5Hover] = useState("/assets/img5.png");
    const [img6Hover, setImg6Hover] = useState("/assets/img6.png");

    const [hoverIndex, setHoverIndex] = useState(null);

    const clientes = useMemo(() => [
        { imagem: "assets/clientes1.jpg" },
        { imagem: "assets/clientes2.jpg" },
        { imagem: "assets/clientes3.jpg" },
        { imagem: "assets/clientes4.jpg" },
        { imagem: "assets/clientes5.jpg" },
        { imagem: "assets/clientes6.jpg" },
    ], []);

    const trackRef = useRef(null);
    const controls = useAnimation();
    const [contentWidth, setContentWidth] = useState(0);

    // Calcula largura total da lista original
    useEffect(() => {
        if (!trackRef.current) return;

        // largura da lista duplicada dividido por 2
        const width = trackRef.current.scrollWidth / 2;
        setContentWidth(width);
    }, [clientes]);

    // Animação infinita
    const speed = 80
    useEffect(() => {
        if (contentWidth <= 0) return;

        const duration = contentWidth / speed; // tempo da animação

        const startLoop = async () => {
            await controls.start({
                x: [-0, -contentWidth], // desloca metade
                transition: {
                    duration,
                    ease: "linear",
                    repeat: Infinity,
                    repeatType: "loop",
                },
            });
        };

        startLoop();
    }, [contentWidth, speed, controls]);

    if (!clientes || clientes.length === 0) return null;

    // lista duplicada
    const duplicated = [...clientes, ...clientes];


    return (
        <>
            <Header active="home" />
            <section
                style={{
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        minHeight: "100vh", // melhor que height fixa
                        backgroundImage: `
                            linear-gradient(
                                135deg,
                                rgba(255, 255, 255, 0.9) 0%,
                                rgba(227, 242, 253, 0.35) 100%
                            ),
                            url(${images[index]})
                        `,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        transition: "background-image 0.8s ease",
                        backgroundAttachment: window.innerWidth < 768 ? "scroll" : "fixed",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#0062A6",
                        textAlign: "center",
                        padding: window.innerWidth < 768 ? "0 16px" : "0 40px"
                    }}
                >
                    <h1
                        style={{
                            fontSize: window.innerWidth < 768 ? "1.6rem" : "2.8rem",
                            fontWeight: 600,
                            lineHeight: "1.2",
                            maxWidth: "900px"
                        }}
                    >
                        Análise Tributária Inteligente para Empresas Inovadoras
                    </h1>
                </div>

                {/* Botão anterior */}
                <button
                    onClick={prev}
                    style={{
                        position: "absolute",
                        left: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(0,0,0,0.4)",
                        color: "#fff",
                        border: "none",
                        padding: "15px",
                        fontSize: "20px",
                        cursor: "pointer",
                    }}
                >
                    ‹
                </button>

                {/* Botão próximo */}
                <button
                    onClick={next}
                    style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(0,0,0,0.4)",
                        color: "#fff",
                        border: "none",
                        padding: "15px",
                        fontSize: "20px",
                        cursor: "pointer",
                    }}
                >
                    ›
                </button>
            </section>
            <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "-100px",
            }}>
                <div style={{
                    width: window.innerWidth > 768 ? "80%" : "100%",
                    maxWidth: "1600px",
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    padding: "20px"
                }}>
                    <img
                        style={{ cursor: "pointer", width: "15%", minWidth: "170px" }}
                        src={img1Hover}
                        alt={`Partner`}
                        onMouseEnter={() => setImg1Hover("/assets/img1hover.png")}
                        onMouseLeave={() => setImg1Hover("/assets/img1.png")}
                    />
                    <img
                        style={{ cursor: "pointer", width: "15%", minWidth: "170px" }}
                        src={img2Hover}
                        alt={`Partner`}
                        onMouseEnter={() => setImg2Hover("/assets/img2hover.png")}
                        onMouseLeave={() => setImg2Hover("/assets/img2.png")}
                    />
                    <img
                        style={{ cursor: "pointer", width: "15%", minWidth: "170px" }}
                        src={img3Hover}
                        alt={`Partner`}
                        onMouseEnter={() => setImg3Hover("/assets/img3hover.png")}
                        onMouseLeave={() => setImg3Hover("/assets/img3.png")}
                    />
                    <img
                        style={{ cursor: "pointer", width: "15%", minWidth: "170px" }}
                        src={img4Hover}
                        alt={`Partner`}
                        onMouseEnter={() => setImg4Hover("/assets/img4hover.png")}
                        onMouseLeave={() => setImg4Hover("/assets/img4.png")}
                    />
                    <img
                        style={{ cursor: "pointer", width: "15%", minWidth: "170px" }}
                        src={img5Hover}
                        alt={`Partner`}
                        onMouseEnter={() => setImg5Hover("/assets/img5hover.png")}
                        onMouseLeave={() => setImg5Hover("/assets/img5.png")}
                    />
                    <img
                        style={{ cursor: "pointer", width: "15%", minWidth: "170px" }}
                        src={img6Hover}
                        alt={`Partner`}
                        onMouseEnter={() => setImg6Hover("/assets/img6hover.png")}
                        onMouseLeave={() => setImg6Hover("/assets/img6.png")}
                    />
                </div>
            </div>

            <div style={{ width: "100%", display: 'flex', justifyContent: "center", backgroundImage: "url('/assets/backgroundImg.jpg')", backgroundSize: "cover", backgroundPosition: "center", height: "fit-content", backgroundAttachment: "fixed", marginTop: "-80px" }}>
                <div style={{ width: "70%", display: 'flex', justifyContent: "center", marginTop: "50px", padding: "50px", height: "fit-content" }}>
                    <div style={{ textAlign: "center" }}>
                        <h1 style={{ color: "#0062A6" }}>SOBRE NÓS</h1>
                        <div style={{ width: "100px", height: "5px", backgroundColor: "#0062A6", margin: "20px auto" }}></div>
                        <h2 style={{ fontWeight: 200, color: "#0062A6" }}>ASSESSORIA TRIBUTÁRIA E PROCESSAMENTO DE DADOS</h2>
                        <p style={{ width: "100%", textAlign: "center", marginTop: "20px", color: "#525252ff", lineHeight: "1.6", fontSize: "20px", height: "fit-content" }}>
                            A FiscalTec é especializada na área fiscal, visa prover soluções inteligentes para empresas dos mais diversos ramos de atividade. Possui “Know How” e dispõe de Softwares próprios específicos, capazes de auxiliar na tarefa extensa e burocrática de forma ágil e segura. Construir laços duradouros e entregar serviços diferenciados, completos e personalizados para empresas dos mais diversos ramos de atividade é o foco da FiscalTec. A empresa investe constantemente em estudos, inovação e dispõe de profissionais integrados e especializados em importantes áreas correlatas à tributação.
                        </p>
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-around", marginTop: "50px", flexWrap: "wrap" }}>
                            <div style={{ width: "25%", minWidth: "250px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <img src="/assets/sobre1.png" alt="Missão" style={{ width: "200px", marginBottom: "20px" }} />
                                <h3 style={{ color: "#0062A6", fontSize: "35px" }}>CRÉDITOS APURADOS</h3>
                                <div style={{ width: "50px", height: "4px", backgroundColor: "#0062A6", marginTop: "20px", marginBottom: "20px" }} />
                                <p style={{ fontSize: "60px", fontWeight: "inherit", color: "#0062A6" }}>+ R$700 Mi</p>
                            </div>
                            <div style={{ width: "25%", minWidth: "250px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <img src="/assets/sobre2.jpg" alt="Missão" style={{ width: "200px", marginBottom: "20px" }} />
                                <h3 style={{ color: "#0062A6", fontSize: "35px" }}>ABRANGÊNCIA NACIONAL</h3>
                                <div style={{ width: "50px", height: "4px", backgroundColor: "#0062A6", marginTop: "20px", marginBottom: "20px" }} />
                                <p style={{ fontSize: "60px", fontWeight: "inherit", color: "#0062A6" }}>100%</p>
                            </div>
                            <div style={{ width: "25%", minWidth: "250px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <img src="/assets/sobre3.png" alt="Missão" style={{ width: "200px", marginBottom: "20px" }} />
                                <h3 style={{ color: "#0062A6", fontSize: "35px" }}>TEMAS / BENEFÍCIOS TRIBUTÁRIOS</h3>
                                <div style={{ width: "50px", height: "4px", backgroundColor: "#0062A6", marginTop: "20px", marginBottom: "20px" }} />
                                <p style={{ fontSize: "60px", fontWeight: "inherit", color: "#0062A6" }}>+ 30</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                }}
            >
                {/* ESQUERDA */}
                <div
                    style={{
                        width: window.innerWidth < 900 ? "100%" : "50%",
                        // minWidth: "300px",
                        height: "500px",
                        display: "flex",
                        justifyContent: window.innerWidth < 900 ? "flex-end" : "center",
                        alignItems: "center",
                        backgroundImage:
                            "linear-gradient(rgba(0, 60, 129, 0.8), rgba(0, 57, 133, 0.8)), url('/assets/contabilidade.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "500px",
                            height: "auto",
                            padding: "20px",
                            // marginRight: window.innerWidth < 900 ? "20px" : "0",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",

                            /* MOBILE */
                            ...(window.innerWidth < 900
                                ? {
                                    marginRight: 0,
                                    marginLeft: 0,
                                    height: "auto",
                                    padding: "10px",
                                }
                                : {}),
                        }}
                    >
                        <h1 style={{ color: "white", fontSize: window.innerWidth < 600 ? "28px" : "40px" }}>
                            SÓCIOS
                        </h1>

                        <div
                            style={{
                                width: "80px",
                                height: "4px",
                                backgroundColor: "white",
                                margin: "20px 0",
                            }}
                        ></div>

                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <button
                                onClick={prevSocio}
                                style={{
                                    background: "transparent",
                                    border: "2px solid white",
                                    color: "white",
                                    padding: "5px",
                                    fontSize: "25px",
                                    height: "45px",
                                    width: "45px",
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                }}
                                aria-label="Previous"
                            >
                                ‹
                            </button>

                            <div
                                style={{
                                    width: window.innerWidth < 600 ? "120px" : "150px",
                                    height: window.innerWidth < 600 ? "120px" : "150px",
                                    backgroundImage: `url(${imagesSocios[indexSocio].src})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    transition: "background-image 0.8s ease",
                                    border: "3px solid white",
                                    borderRadius: "50%",
                                }}
                            />

                            <button
                                onClick={nextSocio}
                                style={{
                                    background: "transparent",
                                    border: "2px solid white",
                                    color: "white",
                                    padding: "5px",
                                    fontSize: "25px",
                                    height: "45px",
                                    width: "45px",
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                }}
                                aria-label="Next"
                            >
                                ›
                            </button>
                        </div>

                        <h2
                            style={{
                                marginTop: "20px",
                                color: "white",
                                fontSize: window.innerWidth < 600 ? "20px" : "25px",
                            }}
                        >
                            {imagesSocios[indexSocio].name}
                        </h2>

                        <p style={{ color: "white" }}>Sócio</p>

                        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                            <button
                                style={{
                                    background: "transparent",
                                    border: "2px solid white",
                                    color: "white",
                                    padding: "10px",
                                    fontSize: "14px",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                }}
                                onClick={() => navigate("../Socios")}
                            >
                                MAIS DETALHES
                            </button>
                        </div>
                    </div>
                </div>

                {/* DIREITA */}
                <div
                    style={{
                        width: "50%",
                        minWidth: "300px",
                        backgroundColor: "#1e72adff",
                        height: "500px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                        /* MOBILE */
                        ...(window.innerWidth < 900
                            ? {
                                height: "auto",
                                padding: "20px 0",
                                width: "100%",
                            }
                            : {}),
                    }}
                >
                    <div
                        style={{
                            width: "80%",
                            maxWidth: "600px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            color: "white",
                            textAlign: "center",
                            padding: "20px",
                        }}
                    >
                        <h1
                            style={{
                                fontWeight: 600,
                                fontSize: window.innerWidth < 600 ? "28px" : "45px",
                            }}
                        >
                            SOFTWARES PRÓPRIOS ESPECÍFICOS
                        </h1>

                        <p>(FERRAMENTA EXCLUSIVA FISCALTEC)</p>

                        <div
                            style={{
                                width: "80px",
                                height: "4px",
                                backgroundColor: "white",
                                marginTop: "20px",
                                marginBottom: "20px",
                            }}
                        ></div>

                        <p style={{ fontSize: window.innerWidth < 600 ? "16px" : "20px", lineHeight: "1.8" }}>
                            Além de especialistas na área tributária, a FiscalTec dispõe de ferramentas
                            tecnológicas que auxiliam na comprovação, elaboração de relatórios e
                            identificação das oportunidades fiscais.
                        </p>
                    </div>
                </div>
            </div>

            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingTop: "50px",
                    paddingBottom: "100px",
                    "--size": "3px",
                    background:
                        "conic-gradient(#ddd 25%, transparent 0 50%, #8b8b8bff 0 75%, transparent 0) 0 0 / var(--size) var(--size)",
                }}
            >
                {/* TÍTULO */}
                <div>
                    <h1
                        style={{
                            color: "#0062A6",
                            fontSize: window.innerWidth < 600 ? "28px" : "40px",
                            textAlign: "center",
                        }}
                    >
                        SOLUÇÕES EM EVIDÊNCIA
                    </h1>
                </div>

                {/* LINHA */}
                <div
                    style={{
                        width: "100px",
                        height: "5px",
                        backgroundColor: "#1e72adff",
                        marginTop: "20px",
                        marginBottom: "20px",
                    }}
                />

                {/* SUBTÍTULO */}
                <p
                    style={{
                        width: window.innerWidth < 600 ? "90%" : "60%",
                        textAlign: "center",
                        color: "#1e72adff",
                        fontSize: window.innerWidth < 600 ? "16px" : "20px",
                        lineHeight: "1.6",
                    }}
                >
                    ALGUMAS DE NOSSAS SOLUÇÕES PARA SUA EMPRESA
                </p>

                {/* CARDS */}
                <div
                    style={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        marginTop: "50px",
                        gap: "20px",
                    }}
                >
                    {solucoes.map((solucao, idx) => (
                        <div
                            key={idx}
                            style={{
                                width: window.innerWidth < 768 ? "100%" : "600px",
                                height: "auto",
                                display: "flex",
                                flexDirection: window.innerWidth < 600 ? "column" : "row",
                                justifyContent: "space-between",
                                border: hoverIndex === idx ? "2px solid #1e72ad" : "1px solid #e0e0e0",
                                borderRadius: "10px",
                                padding: "10px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "white",
                                cursor: "pointer",
                            }}
                            onMouseEnter={() => setHoverIndex(idx)}
                            onMouseLeave={() => setHoverIndex(null)}
                            onClick={() => navigate("../SolucoesEmEvidencia")}
                        >
                            {/* IMAGEM */}
                            <div
                                style={{
                                    width: window.innerWidth < 600 ? "150px" : "200px",
                                    height: window.innerWidth < 600 ? "150px" : "200px",
                                    backgroundImage: `url(${solucao.src})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    borderRadius: window.innerWidth < 600 ? "10px" : "0",
                                    margin: "0 auto"
                                }}
                            />

                            {/* TEXTO */}
                            <div
                                style={{
                                    width: window.innerWidth < 600 ? "100%" : "380px",
                                    padding: "10px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    textAlign: window.innerWidth < 600 ? "center" : "left",
                                }}
                            >
                                <h3
                                    style={{
                                        marginBottom: "20px",
                                        color: "#1e72adff",
                                        fontSize: window.innerWidth < 600 ? "20px" : "24px",
                                    }}
                                >
                                    {solucao.title}
                                </h3>

                                <p
                                    style={{
                                        color: "gray",
                                        fontSize: window.innerWidth < 600 ? "16px" : "18px",
                                        lineHeight: "1.5",
                                    }}
                                >
                                    {solucao.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>



            <div style={{ width: "100%", display: 'flex', justifyContent: "center" }}>
                <div style={{ width: "70%", display: 'flex', justifyContent: "center", marginTop: "50px", padding: "50px", height: "fit-content" }}>
                    <div style={{ textAlign: "center" }}>
                        <h1 style={{ color: "#0062A6" }}>COMPROMISSOS COM RESULTADOS</h1>
                        <div style={{ width: "100px", height: "5px", backgroundColor: "#0062A6", margin: "20px auto" }}></div>
                        <h2 style={{ fontWeight: 200, color: "#0062A6" }}>ALGUNS DE NOSSOS CLIENTES </h2>
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    overflow: "hidden",
                    padding: "10px 0",
                }}
            >
                <motion.div
                    ref={trackRef}
                    animate={controls}
                    style={{
                        display: "flex",
                        gap: 20,
                        alignItems: "center",
                        userSelect: "none",
                        pointerEvents: "none", // impede arrastar/clicar
                    }}
                >
                    {duplicated.map((item, idx) => (
                        <div
                            key={idx}
                            style={{
                                minWidth: window.innerWidth < 600 ? 130 : 180,
                                height: 120,
                                borderRadius: 12,
                                overflow: "hidden",
                                background: "#fff",
                                flexShrink: 0,
                            }}
                        >
                            <img
                                src={item.imagem}
                                alt={item.nome || `cliente-${idx}`}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                    pointerEvents: "none",
                                }}
                                draggable={false}
                            />
                        </div>
                    ))}
                </motion.div>
            </div>
            <Footer />
        </>
    );
};

export default Home;